module.exports = {
	"api": {
		"zhike": "//www.smartstudy.com/api",
		"ti": "//ti.smartstudy.com/api",
		"tpo": "//practice.smartstudy.com/api",
		"promotion": "//p.smartstudy.com/zt",
		"pigai": "//pigai.smartstudy.com/api",
		"smart": "//sp.smartstudy.com/api",
		"ieltsApp": "//api.smartstudy.com/ielts/api",
		"zhanToefl": "//zhan-toefl.smartstudy.com/api",
		"uskidAdmin": "//admin-old.uskid.com/v2",
		"uskid": "//api.uskid.com",
		"transformService": "//tr.smartstudy.com/api",
		"uskidAres": "//admin-old.uskid.com/campus",
		"uskidSite": "//site.uskid.com/api",
		"uskidIm": "//im.uskid.com",
		"smartAdaptation": "//sp.smartstudy.com/api",
		"uskidGame": "//admin-old.uskid.com/h5",
		"scorpio": "//data-api.smartstudy.com",
		"word": "//api.smartstudy.com/word",
		"file": "//api.smartstudy.com/file",
		"social": "//api.smartstudy.com/social",
		"crm2": "//crm2.smartstudy.com/api",
		"tag": "//api.smartstudy.com/tag",
		"appsync": "//appsync.smartstudy.com",
		"smartInside": "//smartxue.com/api",
		"studyStat": "//api.smartstudy.com/study-stat/api"
	},
	"EXAM_MAP": {
		"toefl": 1,
		"ielts": 2,
		"gre": 3,
		"gmat": 5,
		"sat": 6,
		"kaoyan": 7,
		"proficiency": 9,
		"goabroad": 10,
		"career": 14,
		"gaokao": 15,
		"cet4": 8
	},
	"userCenter": {
		"from": "pc",
		"group": "C",
		"source": "www.smartstudy.com",
		"token": "N0LXYPFL03O4TU2WQEU536NDJR7IJKII"
	},
	"port": 8080,
	"cdnPath": "//media8.smartstudy.com/ti",
	"site": {
		"beikao": "//beikao.smartstudy.com",
		"zhike": "//www.smartstudy.com",
		"ti": "//ti.smartstudy.com",
		"tim": "//tim.smartstudy.com",
		"tpo": "//practice.smartstudy.com",
		"pigai": "//pigai.smartstudy.com",
		"pigaim": "//pigai.smartstudy.com",
		"px": "//promotionx.smartstudy.com",
		"bbs": "//bbs.smartstudy.com?pid=kqpyk53z",
		"kaowei": "//app.smartstudy.com/kaowei",
		"vip": "//vip.smartstudy.com",
		"job": "//job.smartstudy.com",
		"school": "//www.beikaodi.com/school",
		"zhanToefl": "//zhan-toefl.smartstudy.com",
		"wapTi": "//ti.smartstudy.com",
		"uskid": "//uskid.com",
		"jiameng": "//jiameng.smartstudy.com",
		"xxd": "//xxd.smartstudy.com",
		"smart": "//sp.smartstudy.com",
		"toeflTi": "//ti-toefl.smartstudy.com",
		"promotion": "//p.smartstudy.com",
		"social": "//api.smartstudy.com/social",
		"navTi": "//ti-nav.smartstudy.com",
		"newTiToefl": "//ti-toefl.smartstudy.com",
		"newTiIelts": "//ti-ielts.smartstudy.com",
		"class": "//class.uskid.com",
		"adaptation": "//zsy.smartstudy.com",
		"social_izhike": "//api.izhike.net/social",
		"zhike_izhike": "//www.izhike.net",
		"inside": "//inside.uskid.com"
	},
	"cdnPrefix": "//media8.smartstudy.com/ti",
	"cdnCommon": "//media8.smartstudy.com",
	"userService": {
		"url": "//api.smartstudy.com/usert",
		"tower": "1nMvh3jwQMaGse2xCT06lsx5AXDqpVXt",
		"token": "N0LXYPFL03O4TU2WQEU536NDJR7IJKII"
	},
	"cardService": {
		"url": "//api.smartstudy.com/card",
		"tower": "1nMvh3jwQMaGse2xCT06lsx5AXDqpVXt"
	},
	"sa": {
		"sdk_url": "//media8.smartstudy.com/data/sa/1.10.6/sensorsdata.min.js",
		"heatmap_url": "//media8.smartstudy.com/data/sa/1.10.6/heatmap.min.js",
		"server_url": "//sea.smartstudy.com/sa?project=production",
		"name": "sa",
		"sdk_amd_url": "//media8.smartstudy.com/data/sa/1.10.6/sensorsdata.amd.min.js",
		"web_url": "//sa.smartstudy.com/"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.json
 ** module id = 8
 ** module chunks = 0
 **/